import * as React from "react";

import { LightStyled } from "./Light.style";

export const Light = () => <LightStyled>UNDER ATTACK</LightStyled>;
